<dx-button class="aiButton"
           [text]="text"
           [icon]="icon"
           [hint]="hint"
           stylingMode="contained"
           [disabled]="disabled"
           (onClick)="clicked.emit()">
</dx-button>
